(function () {
  'use strict';

  // Skip in Shopify editor — don't interfere with theme customization UX
  if (window.Shopify && window.Shopify.designMode) return;

  // 1. Disable right-click everywhere except form fields
  document.addEventListener('contextmenu', function (e) {
    if (e.target.matches('input, textarea, [contenteditable]')) return;
    e.preventDefault();
    return false;
  }, false);

  // 2. Disable image/video drag
  document.addEventListener('dragstart', function (e) {
    if (e.target.matches('img, video')) {
      e.preventDefault();
      return false;
    }
  }, false);

  // 3. Disable text selection starting on media elements
  document.addEventListener('selectstart', function (e) {
    if (e.target.matches('img, video')) {
      e.preventDefault();
      return false;
    }
  }, false);

  // 4. Block common save / view-source / DevTools shortcuts
  document.addEventListener('keydown', function (e) {
    var ctrl = e.ctrlKey || e.metaKey;
    // Ctrl+S / Cmd+S — save page
    if (ctrl && e.key === 's') { e.preventDefault(); return false; }
    // Ctrl+U / Cmd+U — view source
    if (ctrl && e.key === 'u') { e.preventDefault(); return false; }
    // F12 — DevTools
    if (e.key === 'F12') { e.preventDefault(); return false; }
    // Ctrl+Shift+I / Cmd+Opt+I — DevTools
    if (ctrl && e.shiftKey && (e.key === 'I' || e.key === 'i')) { e.preventDefault(); return false; }
    // Ctrl+Shift+C / Cmd+Opt+C — DevTools inspector
    if (ctrl && e.shiftKey && (e.key === 'C' || e.key === 'c')) { e.preventDefault(); return false; }
  }, false);

  // 5. Apply video-specific protections after DOM is ready
  function protectVideo(v) {
    v.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback');
    v.setAttribute('disablepictureinpicture', '');
    v.oncontextmenu = function () { return false; };
  }

  function protectAllVideos() {
    document.querySelectorAll('video').forEach(protectVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', protectAllVideos);
  } else {
    protectAllVideos();
  }

  // Cover videos added dynamically (lazy-loaded sections, etc.)
  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches('video')) protectVideo(n);
          n.querySelectorAll && n.querySelectorAll('video').forEach(protectVideo);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
